import { createLucideIcon } from "lucide-react";

/**
 * A single sequence strand with a gentle wave.
 */
export const SequenceIcon = createLucideIcon("sequence", [
  ["path", { d: "M2 12c2-1.5 4-1.5 6 0s4 1.5 6 0 4-1.5 6 0", key: "svg-0" }],
]);

/**
 * Multiple aligned sequence strands with a vertical alignment bar.
 */
export const AlignmentIcon = createLucideIcon("alignment", [
  ["path", { d: "M2 7c2-1.5 4-1.5 6 0s4 1.5 6 0 4-1.5 6 0", key: "svg-0" }],
  ["path", { d: "M2 12c2-1.5 4-1.5 6 0s4 1.5 6 0 4-1.5 6 0", key: "svg-1" }],
  ["path", { d: "M2 17c2-1.5 4-1.5 6 0s4 1.5 6 0 4-1.5 6 0", key: "svg-2" }],
  ["line", { x1: "12", y1: "4", x2: "12", y2: "20", key: "svg-3" }],
]);

/**
 * Multiple sequence strands stacked together.
 */
export const SequenceCollectionIcon = createLucideIcon("sequence-collection", [
  ["path", { d: "M2 7c2-1.5 4-1.5 6 0s4 1.5 6 0 4-1.5 6 0", key: "svg-0" }],
  ["path", { d: "M2 12c2-1.5 4-1.5 6 0s4 1.5 6 0 4-1.5 6 0", key: "svg-1" }],
  ["path", { d: "M2 17c2-1.5 4-1.5 6 0s4 1.5 6 0 4-1.5 6 0", key: "svg-2" }],
]);

/**
 * A phylogenetic tree with branching structure.
 */
export const PhyloTreeIcon = createLucideIcon("phylo-tree", [
  ["path", { d: "M3 12h6", key: "svg-0" }],
  ["path", { d: "M9 6v12", key: "svg-1" }],
  ["path", { d: "M9 6h6", key: "svg-2" }],
  ["path", { d: "M9 12h6", key: "svg-3" }],
  ["path", { d: "M9 18h6", key: "svg-4" }],
  ["path", { d: "M15 3v6", key: "svg-5" }],
  ["path", { d: "M15 3h6", key: "svg-6" }],
  ["path", { d: "M15 9h6", key: "svg-7" }],
]);

/**
 * A single X-shaped chromosome.
 */
export const ChromosomeIcon = createLucideIcon("chromosome", [
  [
    "path",
    {
      d: "M7 5c4 0 4 14 0 14",
      strokeLinecap: "round",
      transform: "rotate(45 12 12)",
      key: "svg-0",
    },
  ],
  [
    "path",
    {
      d: "M17 5c-4 0-4 14 0 14",
      strokeLinecap: "round",
      transform: "rotate(45 12 12)",
      key: "svg-1",
    },
  ],
  ["circle", { cx: "12", cy: "12", r: "1.5", key: "svg-2" }],
]);
